import React from 'react';
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Icon,
  Image
} from 'semantic-ui-react';
import {DateInput} from 'semantic-ui-calendar-react';

const scamOptions = [
  { key: 'a', text: 'ICO', value: 'ico' },
  { key: 'b', text: 'Phishing', value: 'phishing' },
  { key: 'c', text: 'Darknet', value: 'darknet' },
  { key: 'd', text: 'Fake Service', value: 'fake_service' }
]

const coinOptions = [
  { key: 'a', text: 'Bitcoin', value: 'bitcoin' },
  { key: 'b', text: 'Ethereum', value: 'ethereum' },
  { key: 'b', text: 'Litecoin', value: 'litecoin' },
  { key: 'b', text: 'Ripple', value: 'ripple' }
]

export default () => (
  <Grid centered columns={1}>
    <Grid.Column>
      <Header as="h2" textAlign="center">
        Scam Submission Form
      </Header>
      <Message color='blue'>
        <Header as='h3'>Cooperate with authorities to reclaim your money</Header>
        Help secure the crypto space by reporting malicious actors. CryptoLynx works with exchanges to verify frauds and return the money to the right owners.
      </Message>
      <Segment>
        <Form size="large">
          <Form.Select
            fluid
            label='Select coin / token type'
            options={coinOptions}
            placeholder='Coin Type'
          />
          <Form.Group widths='equal'>
            <Form.Input
              inline
              width={6}
              icon="user"
              label='Your address'
              iconPosition="left"
              placeholder="Your address"
            />
            <Image src='/verify_button.png'/>
            <Button width={2} size="medium">
              Verify
            </Button>
          </Form.Group>
          <Form.Input
            fluid
            label="Scamer's address"
            icon={<Icon name='user' color='red'/>}
            iconPosition="left"
            placeholder="Scammer's address"
          />
          <Form.Group widths='equal'>
            <Form.Select
              fluid label='Scam Type'
              options={scamOptions}
              placeholder='Scam Type'
            />

            <DateInput
              name="date"
              label = "Date of Scam"
              placeholder="Date"
              value={new Date()}
              iconPosition="left"
            />
            <Form.Input fluid label='Amount Scammed' placeholder='Amount' />
          </Form.Group>
          <Form.TextArea label='Additional details' placeholder='Tell us more details about the scam...' />
          <Form.Input icon='upload' placeholder='Upload Supporting Documents' type='file' />
          <Form.Input fluid label='Email' placeholder='We will verify the email and contact you with the results' />

          <Button color="blue" fluid size="large" onClick= {() => console.log('hello world')}>
            Submit
          </Button>
        </Form>
      </Segment>

    </Grid.Column>
  </Grid>
);
